/* eslint-disable security/detect-non-literal-regexp */
import { Tab, Tabs } from '@mui/material'
import { useLocation, matchRoutes, useNavigate } from 'react-router-dom'
import { RootRoute } from '..'
import { useAbsolutePath } from '../../hooks/absolute-path'
import { useAuthorization } from '../../hooks/authorization'
import { useTranslation } from 'react-i18next'

export const ReportTabs = () => {
  const generatePath = useAbsolutePath()
  const location = useLocation()
  const navigate = useNavigate()
  const { t } = useTranslation(['reports'])

  const matchedRoute = matchRoutes(
    [
      { path: RootRoute.ReportJobsOverview },
      { path: RootRoute.ReportJobsYour },
      { path: RootRoute.ReportJobsAll },
    ],
    location.pathname.replace(
      new RegExp(`${RootRoute.ReportJobEditTemplates}.*`),
      '',
    ),
  )

  const matchedPath = matchedRoute?.at(0)?.route.path

  const {
    modules: { reportsFullPermission },
  } = useAuthorization()

  return (
    <Tabs
      onChange={(_, route) => void navigate(generatePath(route))}
      value={matchedPath}
      variant="standard"
      sx={{
        '.MuiButtonBase-root': {
          borderColor: 'transparent',
        },
      }}
    >
      <Tab label={t('reports:overview')} value={RootRoute.ReportJobsOverview} />
      <Tab label={t('reports:your_reports')} value={RootRoute.ReportJobsYour} />
      {reportsFullPermission && (
        <Tab label={t('reports:all_reports')} value={RootRoute.ReportJobsAll} />
      )}
    </Tabs>
  )
}
